import { Box, makeStyles, Grid, Typography } from "@material-ui/core";

import { COLORS } from "../../theme/colors";
import { Icon } from "../base";

const useStyles = makeStyles(() => ({
  root: {
    width: "fit-content",
  },
  iconBlock: {
    width: 85,
    height: 85,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: COLORS.white,
    borderRadius: 50,
    marginRight: 16,
  },
  title: {
    fontWeight: "bold",
    textTransform: "uppercase",
  },
}));

export const IconTitle = ({ iconSrc, title, rootStyle, iconBlockStyle }) => {
  const classes = useStyles();

  return (
    <Grid
      container
      alignItems="center"
      style={{ marginTop: 25, marginBottom: 30, ...rootStyle }}
      className={classes.root}
    >
      <Box className={classes.iconBlock} style={iconBlockStyle}>
        <Icon src={iconSrc} />
      </Box>
      <Typography className={classes.title}>{title}</Typography>
    </Grid>
  );
};
